import {Component, HostBinding, Input} from '@angular/core';
import {BlockElementGallery} from 'app/entities/blockElements/blockElementGallery';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';
import {Blocks} from 'app/entities/blockElements/block.entity';

@Component({
  selector: 'app-block-gallery-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementGalleryComponent extends BlockElementAbstractComponent<BlockElementGallery> {
}
